export default {
  reveseral_amount: 'Reversal amount',
  account_overview: 'Account Overview',
  balance: 'Balance',
  balance_available: 'Balance Available',
  top_up: 'Top Up',
  cash_out: 'Cash Out',
  settlement_cycle: 'Settlement Period', // 会计总览页
  settlement_amount: 'Settlement Amount',
  transactions_number: 'Number',
  transaction_status: 'Status',
  transaction_date: 'Transaction Date', // 支付交易明细
  response_date: 'Response Date', // 支付交易明细
  transaction_type: 'Transaction Type',
  update_time: 'Update Time',
  withdraw_time: 'Cash Out Time',
  recharge_time: 'Top Up Time',
  details: 'Details',
  details_excel_download: 'Details Excel Download',
  merchant_order_id: 'Merchant Order ID',
  transaction_id: 'Transaction ID',
  pay_trans_id: 'Payin ID',
  po_trans_id: 'Disburse ID', // 代付交易明细
  create_time: 'Create Time',
  complete_time: 'Complete Time',
  po_fee_plan_id: 'Pay Out Fee Plan ID',
  recipient_name: 'Recipient Name',
  recipient_id_type: 'Recipient ID Type',
  recipient_id: 'Recipient ID',
  recipient_birth_date: 'Recipient Birth Date',
  recipient_mobile: 'Recipient Mobile',
  recipient_channel: 'Receiving Channel',
  recipient_account: 'Recipient Account',
  account_holder_name: 'Account Holder Name',
  account_no: 'Account No.',
  recipient_card: 'Recipient Card',
  money_source: 'Source of Funds',
  po_fee: 'Fee',
  po_trans_status: 'Status',
  cash_out_date: 'Cash Out Date', // 提现记录界面
  amount: 'Amount',
  operator: 'Operator',
  status: 'Status',
  note: 'Note',
  balance_record_type: 'Record Category', // 变动类目 Record Category: 原余额变动类型
  init_balance: 'Initial Balance',
  balance_record_id: 'Record ID',
  transaction_amount: 'Amount',
  balance_record_status: 'Status',
  current_balance: 'Current Balance',
  remitter_information: 'Remitter Information',
  payee_information: 'Payee Information',
  enter_recharge_amount: 'Please enter the top up amount',
  enter_withdraw_amount: 'Please enter the withdraw amount',
  withdrawal_account_information: 'Withdraw Account Information',
  bank: 'Bank',
  bank_account: 'Bank Account No.',
  bank_account_name: 'Bank Account Holder',
  bank_address: 'Bank Address',
  in_transit_settlement_amount: 'In-transit Settlement Amount',
  amount_in_transit: 'Amount In Transit',
  amount_adb: 'Average Daily Balance',
  branch_no: 'Branch No',
  courier_no: 'Courier No',
  region_no: 'Region No',
  beneficiary_name: 'Beneficiary Name',
  beneficiary_mobile: 'Beneficiary Mobile',
  beneficiary_email: 'Beneficiary Email',
  beneficiary_iban: 'Receiver IBAN',
  beneficiary_swift_code: 'SWIFT Code',
  beneficiary_bank_address: 'Receiver Bank Address',
  beneficiary_en_first_name: 'Receiver English First Name',
  beneficiary_en_last_name: 'Receiver English Last Name',
  beneficiary_native_first_name: 'Receiver Local First Name',
  beneficiary_native_last_name: 'Receiver Local Last Name',
  beneficiary_account_type: 'Beneficiary Account Type',
  account_type: 'Account Type',
  account_type_mobile_number: 'Mobile Number',
  account_type_ewallet_id: 'E-Wallet',
  beneficiary_type: 'Beneficiary Type',
  beneficiary_category: 'Beneficiary Category',
  beneficiary_category_placeholder: 'Select beneficiary category',
  beneficiary_category_required: 'Beneficiary category cannot be empty',
  beneficiary_category_individual: 'Individual',
  beneficiary_category_organization: 'Organization',
  recipient_account_type: 'Recipient Account Type',
  short_name: 'Short Name',
  receiving_channel: 'Receiving Channel',
  amount_limit: 'Amount Limit',
  beneficiary_account_no: 'Beneficiary Account No.',
  expire_time: 'Expire Time',
  review_comments: 'Review Comments',
  available_balance: 'Available Balance',
  beneficiary: 'Beneficiary',
  beneficiary_channel: 'Beneficiary Channel',
  beneficiary_account: 'Beneficiary Account',
  beneficiary_id: 'Beneficiary ID',
  add_a_beneficiary: 'Add a Beneficiary',
  permanent: 'Permanent',
  account_details: 'Account Details',
  information_details: 'Information Details',
  other: 'Other',
  attachments: 'Attachments',
  beneficiary_details: 'Beneficiary Details',
  payment_details: 'Payment Details',
  beneficiary_account_information: 'Beneficiary Account Information',
  basic_company_information_of_beneficiary: 'Basic Company Information Of Beneficiary',
  full_legal_entity_name_of_beneficiary: 'Full Legal Entity Name Of Beneficiary',
  registered_country: 'Registered Country/Region',
  registered_address: 'Registered Address',
  authorized_representative: 'Authorized Representative',
  signature_of_the_beneficiary: 'Signature Of The Beneficiary',
  full_name: 'Full Name',
  position: 'Position',
  click_to_sign: 'Click to sign',
  payment_description: 'Payment Description',
  cash_out_threshold: 'Cashout Threshold',
  nsds_bill_summary: 'NSDS Bill Summary',
  amount_used: 'NSDS pay amount',
  service_fee: 'Fee',
  repayment_details: 'Repayment Details',
  repayment_plan_amount: 'Planned repayment',
  discount: 'Discounts available',
  total: 'Total',
  go_to_pay: 'Make Payment',
  bill_date: 'Billing Date',
  currency: 'Currency',
  nsds_usage_date: 'NSDS pay date',
  nsds_usage_amount: 'NSDS pay amount',
  nsds_service_fee: 'NSDS fee',
  billing_type: 'Billing Type',
  bill_total_amount: 'Total amount',
  paid_amount: 'Paid',
  pending_amount: 'Outstanding',
  settled: 'Settled',
  unsettled: 'Unsettled',
  bill_status: 'Billing Status',
  nsds_payment_amount: 'NSDS Pay Amount',
  discount_tip_1: 'No service fee will be charged for NSDS fund usage on D day, provided the principal is repaid by',
  discount_tip_2: 'on D+1 day',
  settlement_date: 'Settlement Date',
  per_transaction: 'Tick by Tick',
  per_day: 'Day by Day',
  payment_remark: 'Payment Remark',
  cancel_cash_out: 'Cancel Withdrawal',
  cancel_reason: 'Cancellation Reason',
  confirm_cash_out: 'Confirm Withdrawal',
  withdraw_details: 'Withdraw Details',
  cancel_reason_placeholder: 'Please enter the reason for cancellation...',
  cancel_reason_required: 'Cancel reason cannot be empty',
  cancel_reason_length: 'Length should be 1 to 200 characters'
}
